<template>
    <ion-icon v-if="completed" :icon="checkmarkCircleOutline" color="success"  />
    <colour-coded-priority-icon :priority="source.priority.name" v-else/>
    <ion-label class="ion-margin-start">
        <h2>{{ source.reference }}</h2>
        <p v-if="!hideDue">
            <strong>Due {{ $dateFormatters.distance(deadline) }}</strong>
        </p>
        <p>
            {{ duration }}
        </p>
    </ion-label>
</template>

<script>

import {parseJSON, intervalToDuration} from 'date-fns';
import {IonLabel, IonIcon} from '@ionic/vue';
import {checkmarkCircleOutline} from 'ionicons/icons';
import ColourCodedPriorityIcon from "@/components/ColourCodedPriorityIcon";
import _ from 'lodash';
export default {
    name: "PickListItem",
    props: ['shipment', 'hide-due', 'stocktake', 'completed', 'duration-source'],
    components: {
        ColourCodedPriorityIcon,
        IonIcon, IonLabel
    },
    computed: {
        duration() {
            // get a list of all the dates that various people have 'accepted' this job
            const accepted = _.filter(_.map(this.durationSource, 'pivot.accepted_at'));

            if (accepted.length < 1) {
                return '';
            }
            const started = parseJSON(_.sortBy(accepted)[0]);

            const diff = intervalToDuration({ start: started, end: new Date});

            // updated to use parseJSON because we're now supporting iOS
            const days = _.padStart(diff.days, 2, 0);
            const hours = _.padStart(diff.hours, 2, 0);
            const minutes = _.padStart(diff.minutes, 2, 0);

            if (days < 1) {
                return `${hours}h:${minutes}m`
            } else {
                return `${days}d ${hours}h:${minutes}m`
            }
        },
        source() {
            if (this.shipment) {
                return this.shipment;
            }
            if (this.stocktake) {
                return this.stocktake;
            }
            return {};
        },
        deadline() {
            if (this.shipment) {
                return this.shipment.must_ship_by;
            }

            if (this.stocktake) {
                return this.stocktake.must_complete_by;
            }

            return new Date;
        },
    },
    setup() {
        return {
            checkmarkCircleOutline
        }
    }
}
</script>

<style scoped>

</style>
